import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;


export function findContentBounds(canvas, context) {
    let imgData = context.getImageData(0, 0, canvas.width, canvas.height);
    let counter = 0;
    const pixels = Array.from(imgData.data).filter(() => {
        if (counter === 3) {
            counter = 0;
            return true;
        }
        counter++;
        return false;
    });

    let top = null;
    let bottom = null;
    let left = canvas.width;
    let right = 0;
    for (let y = 0; y < pixels.length - canvas.width; y += canvas.width) {
        const row = pixels.slice(y, y + canvas.width);
        if (row.some(pixel => pixel > 0)) {
            if (top ===  null)
                top = y == 0 ? 0 : y / canvas.width;
            bottom = y / canvas.width;

            //  Find leftmost and rightmost pixels
            let leftmost = null;
            let rightmost = null;
            for (let x = 0; x < row.length; x++) {
                if (!!row[x]) {
                    if (leftmost === null)
                        leftmost = x;
                    rightmost = x;
                }
            }

            if (leftmost < left) left = leftmost;
            if (rightmost > right) right = rightmost;
        }
    }

    return { top, bottom, left, right };
}

export function cropCanvas(canvas, bounds) {
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const croppedCanvas = document.createElement('canvas');
    croppedCanvas.width = width;
    croppedCanvas.height = height;
    const croppedContext = croppedCanvas.getContext('2d');
    croppedContext.drawImage(canvas, -bounds.left, -bounds.top);
    return croppedCanvas;
}

export function cropCanvasByContentBounds(canvas) {
    let context = canvas.getContext('2d');
    let bounds = findContentBounds(canvas, context);
    return cropCanvas(canvas, bounds);
}
